import React, {Component} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar as StarSolid } from '@fortawesome/free-solid-svg-icons'
import { faStar as StarOutline} from '@fortawesome/free-regular-svg-icons'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import { faCogs} from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { faCheckSquare } from '@fortawesome/free-regular-svg-icons'
import { faChartArea } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from "react-router-dom";

const GridView = (props) => {

	let history = useHistory();

    const goToElement = (e) => {
        if (e.context === "site")
            history.push("/locations/" + e.id)
        else if (e.context === "building")
            history.push("/buildings/" + e.id)
        else if (e.context === "space")
            history.push("/spaces/" + e.id)
        else if (e.context === "equipment")
            history.push("/equipment/" + e.id)
    }

    const drawGridElement = (e) => {
//<div className="halo cost" /> 
        let className = "result " + e.type;
        return (
            <div className={className} key={e.name} onClick={() => {goToElement(e)}}>
                <div className="favorite">
                    { e.favorite ? <FontAwesomeIcon icon={StarSolid} /> : <FontAwesomeIcon icon={StarOutline} />  }
                </div>
                <div className="halo-container">
                    { e.suggestions && e.suggestions.length > 0 ?   <div className='halo'></div>  : null }
                </div>
                <div className="result-type" >{e.type}</div>
                <div className="result-label" >{e.name}</div>
                <div className="result-statistics">
                    { e.spaces && e.spaces > 0 ? 
                        <div className="result-statistic">
                            <FontAwesomeIcon icon={faBuilding} className="result-statistic-icon" />
                            <div className="result-text">{e.spaces} Spaces</div>
                        </div> 
                        : null 
                    }
                    { e.equipment && e.equipment > 0 ? 
                        <div className="result-statistic">
                            <FontAwesomeIcon icon={faCogs} className="result-statistic-icon" />
                            <div className="result-text">Equipment: {e.equipment}</div>
                        </div> 
                        : null 
                    }
                    { e.schedules && e.schedules > 0 ? 
                        <div className="result-statistic">
                            <FontAwesomeIcon icon={faCalendarAlt} className="result-statistic-icon" />
                            <div className="result-text">{e.schedules} Schedules </div>
                        </div> 
                        : null 
                    }
                    { e.dashboards && e.dashboards > 0 ? 
                        <div className="result-statistic">
                            <FontAwesomeIcon icon={faChartArea} className="result-statistic-icon" />
                            <div className="result-text">{e.dashboards} {e.dashboards > 1 ? "Dashboards" : "Dashboard"} </div>
                        </div> 
                        : null 
                    }
                    { e.checklists && e.checklists > 0 ? 
                        <div className="result-statistic">
                            <FontAwesomeIcon icon={faCheckSquare} className="result-statistic-icon" />
                            <div className="result-text">{e.checklists} Checklists </div>
                        </div> 
                        : null 
                    }

                </div>

            </div>
        )
    }

    return (
        <div className="grid-results">
            {
                props.searchResults && props.searchResults.map((e) => {
                    return drawGridElement(e);
                })
            }
        </div>

    )

}

export default GridView;
